/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CancelContentsRequestPaymentDto } from '../../models/cancel-contents-request-payment-dto';
import { ContentsRequestPaymentDto } from '../../models/contents-request-payment-dto';

export interface ContentsRequestPaymentControllerCancel$Params {
  id: string;
      body: CancelContentsRequestPaymentDto
}

export function contentsRequestPaymentControllerCancel(http: HttpClient, rootUrl: string, params: ContentsRequestPaymentControllerCancel$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestPaymentDto>> {
  const rb = new RequestBuilder(rootUrl, contentsRequestPaymentControllerCancel.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentsRequestPaymentDto>;
    })
  );
}

contentsRequestPaymentControllerCancel.PATH = '/api/contents-request-payment/{id}/cancel';
